import { createServerFn } from '@tanstack/react-start'
import { getRequest } from '@tanstack/react-start/server'
import { z } from 'zod'
import { auth } from '@server/auth'
import {
  getPlanSummaryById,
  getPublicPlanCardById,
  listPricingPlansFromDb,
} from '@server/plans-db'
import type { PlanAudience } from '@server/plans-db'

const planIdInputSchema = z.object({
  planId: z.string().min(1, 'Plan id is required'),
})

async function resolvePlanAudience(): Promise<PlanAudience> {
  try {
    const request = getRequest()
    const session = await auth.api.getSession({ headers: request.headers })
    return session?.user ? 'authenticated' : 'anonymous'
  } catch {
    return 'anonymous'
  }
}

export const getPublicPlans = createServerFn({ method: 'GET' }).handler(
  async () => {
    const audience = await resolvePlanAudience()
    return await listPricingPlansFromDb(undefined, audience)
  },
)

export const getPlanSummary = createServerFn({ method: 'GET' })
  .inputValidator(planIdInputSchema)
  .handler(async ({ data }) => {
    return await getPlanSummaryById(data.planId)
  })

export const getPublicPlanCard = createServerFn({ method: 'GET' })
  .inputValidator(planIdInputSchema)
  .handler(async ({ data }) => {
    const audience = await resolvePlanAudience()
    return await getPublicPlanCardById(data.planId, undefined, audience)
  })
